import React, { useState, useEffect } from 'react'
import { API_URL, formatDate, secret_key, storedData } from '../components/Constants';

import axios from 'axios';

import { useNavigate } from 'react-router-dom';
import CryptoJS from 'crypto-js';
import loading1 from "../assets/loading.gif"

function TopUpHistory() {
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(true); 
    const [credits, setCredits] = useState([]);

  const encryptedToken = localStorage.getItem('token');
  let decryptedToken = '';

  if (encryptedToken) {
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedToken, secret_key);
      decryptedToken = decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.log('Error.');
    }
  }

  if (storedData) {
    var bytes = CryptoJS.AES.decrypt(storedData, secret_key);
    var logeduserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }

  const token = `Bearer ${decryptedToken}`;

    const fetchCreditHistory = () => {
      setLoading(true);
      let getCompaniesConfig = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${API_URL}/get_onlinepayment_history/${logeduserData?.company_id}`,
        headers: { 
          'Authorization': token
        }
      };

      axios
      .request(getCompaniesConfig)
      .then((response) => {
        setLoading(false);
        setCredits(response?.data)
      })
      .catch((error) => {
        setLoading(false);
      });
    };
  
    useEffect(() => {
        fetchCreditHistory();
    }, []);

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
      };

    const filteredCompanies = credits.filter((company) => {
    const { amt, refrence_no, paid_by, created_at } = company;
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    return (
        amt.toString().toLowerCase().includes(lowerCaseSearchTerm) ||
        refrence_no.toLowerCase().includes(lowerCaseSearchTerm) ||
        paid_by?.toLowerCase().includes(lowerCaseSearchTerm) ||
        created_at.toLowerCase().includes(lowerCaseSearchTerm)
    );
    });

    return (
    
    <div style={{paddingLeft:'10px'}}>
      <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0">Units Top Up History</h1>
                </div>{/* /.col */}
                <div className="col-sm-6">
                  <ol className="breadcrumb float-sm-right">
                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                    <li className="breadcrumb-item active">Companies stats</li>
                  </ol>
                </div>{/* /.col */}
              </div>{/* /.row */}
            </div>{/* /.container-fluid */}
        </div>

      <form className="form-inline justify-content-end searchBar">
        <div className="input-group input-group-sm">
          <input
            className="form-control form-control-navbar"
            type="search"
            placeholder="Search"
            aria-label="Search"
            value={searchTerm}
            onChange={handleSearch}
          />
        </div>
      </form>
      {loading ? (
          <div className="loadingsubcontainer">
            <img className="loadingsubimg" src={loading1} alt="" />
          </div>
        ) : (
      <div className='table-responsive p-0'>
        <table id="example" className="table table-striped">
        <thead>
            <tr>
                <th>Date</th>
                <th>Reference</th>
                <th>Amount</th>
                <th>Rate</th>
                <th>Units</th>
                <th>Paid By</th>
            </tr>
        </thead>
        <tbody>
          {filteredCompanies.map((company, name) => (
            <tr key={name}>
              <td>{company.created_at}</td>
              <td>{company.refrence_no}</td>
              <td>{company.amt}</td>
              <td>{company.rate}</td>
              <td>{company.units}</td>
              <td>{company.paid_by}</td>
            </tr>
          ))}
        </tbody>
    </table>
        </div>
        )}
        
    </div>
  )
}

export default TopUpHistory